import TwitterPostGrid from './TwitterPostGrid.vue'
export default TwitterPostGrid
